import { SharedPortfolios } from '@unistocks/features/shared-portfolios/shared-portfolios';
import { t } from '@unistocks/shared/localization/index.ts';
import Head from 'expo-router/head';

export default function SharedPortfoliosScreen() {
  return (
    <>
      <Head>
        <title>{t('::Menu:SharedPortfolios')}</title>
      </Head>
      <SharedPortfolios />
    </>
  );
}
